import { isEmpty } from 'lodash'

const getStepApi = (steppers, step) => {
  if (!isEmpty(steppers) && steppers?.find((stepper) => stepper?.step === step))
    return true
  return false
}

export default getStepApi
